import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { useAddWishlistProductVariant } from "@temp/@sdk/react";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { Button, Form, TextField } from "../..";
import { RudderAnalytics } from "../../../app/analitics";
import { commonMessages } from "../../../intl";
export function SaveProjectForm(_ref) {
  var onSuccess = _ref.onSuccess,
      productId = _ref.productId,
      selectedProductAttributes = _ref.selectedProductAttributes,
      url = _ref.url,
      variantId = _ref.variantId;
  var intl = useIntl();

  var _useAddWishlistProduc = useAddWishlistProductVariant(),
      _useAddWishlistProduc2 = _slicedToArray(_useAddWishlistProduc, 2),
      add = _useAddWishlistProduc2[0],
      _useAddWishlistProduc3 = _useAddWishlistProduc2[1],
      loading = _useAddWishlistProduc3.loading,
      error = _useAddWishlistProduc3.error,
      data = _useAddWishlistProduc3.data;

  var handleOnSubmit =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(evt, _ref2) {
      var email, urlLink;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref2.email;
              evt.preventDefault();
              add({
                email: email,
                productAttributes: selectedProductAttributes,
                variantId: variantId
              });
              urlLink = url; // @analitics

              RudderAnalytics.track("Product Shared", {
                product_id: productId,
                recipient: email,
                share_via: "EMAIL",
                url: urlLink,
                variant: variantId
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOnSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (!loading && !error && data) {
      var hasErrors = data.wishlistErrors.length;

      if (!hasErrors && onSuccess) {
        onSuccess();
      }
    }
  }, [loading, error, data]);
  return React.createElement(Form, {
    errors: error && [{
      field: "email",
      message: error.message
    }],
    onSubmit: handleOnSubmit
  }, React.createElement(TextField, {
    name: "email",
    autoComplete: "email",
    label: intl.formatMessage(commonMessages.eMail),
    type: "email",
    required: true
  }), React.createElement("div", {
    className: "login__content__button"
  }, React.createElement(Button, _extends({
    className: "red",
    type: "submit"
  }, loading && {
    disabled: true
  }), loading ? intl.formatMessage(commonMessages.loading) : intl.formatMessage(commonMessages.saveProject))));
}